import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { find } from 'lodash'

import { createErrorNotification } from 'store/actions/notifications'
import Api from 'services/Api'
import { Card, List } from 'ui'

import { currentLang, t } from 'translations'

const VersionsModal = ({ Modal }) => {
  const dispatch = useDispatch()
  const [versions, setVersions] = useState([])
  const [selectedVersion, setSelectedVersion] = useState()

  useEffect(() => {
    const fetchVersions = async () => {
      let { versions, success } = await Api.get('versions', { params: { useNewReturn: true } })

      // If the response isn't an array, an error occured
      if (!success) return dispatch(createErrorNotification())
      setVersions(
        versions.map(({ _id, title, releaseNotes }) => {
          // Always return something
          try {
            // Convert release notes string to translated release notes
            return { ...extractReleaseNotes(releaseNotes[currentLang() || 'en']), _id, title }
          } catch (err) {
            return { _id, features: [], improvements: [], fixes: [], title: `ERROR LOADING ${title}` }
          }
        })
      )
      setSelectedVersion(versions?.[0]?._id)
    }

    fetchVersions()
  }, [dispatch])

  const selectedVersionContent = find(versions, { _id: selectedVersion })

  return (
    <>
      <Modal title="components.versions.VERSIONS_MODAL">
        <Card>
          <Card.Body>
            <select className="custom-select" onChange={e => setSelectedVersion(e.target.value)} value={selectedVersion}>
              {versions.map(({ _id, title }) => (
                <option key={_id} value={_id}>
                  {title}
                </option>
              ))}
            </select>
          </Card.Body>
          {typeof selectedVersionContent !== 'undefined' ? (
            <List className="list-group-flush list-group-flush-border mb-2">
              <List.Item>
                <div className="d-flex w-100 justify-content-between">
                  <h6 className="mb-1">{t('components.versions.FEATURES')}</h6>
                </div>
                <ul>
                  {(selectedVersionContent.features || []).map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </List.Item>
              <List.Item>
                <div className="d-flex w-100 justify-content-between">
                  <h6 className="mb-1">{t('components.versions.IMPROVEMENTS')}</h6>
                </div>
                <ul>
                  {(selectedVersionContent.improvements || []).map((improvement, index) => (
                    <li key={index}>{improvement}</li>
                  ))}
                </ul>
              </List.Item>
              <List.Item>
                <div className="d-flex w-100 justify-content-between">
                  <h6 className="mb-1">{t('components.versions.FIXES')}</h6>
                </div>
                <ul>
                  {(selectedVersionContent.fixes || []).map((fix, index) => (
                    <li key={index}>{fix}</li>
                  ))}
                </ul>
              </List.Item>
            </List>
          ) : null}
        </Card>
      </Modal>
    </>
  )
}

export default VersionsModal

// Function to extract the release notes from the string format used by the backend
function extractReleaseNotes(releaseNotes = '') {
  let extract = { features: [], improvements: [], fixes: [] }
  let key = 'features'

  // For each line, check if it's a header or some content
  for (let line of releaseNotes.split('\n')) {
    // If the line is not a string, continue
    if (typeof line !== 'string') continue
    // Remove whitespace
    line = line.trim()
    // Found a header
    if (line[0] === '#') {
      key = line.slice(1)
      continue
    }
    // Only extract values that have a dash at the front
    if (line.slice(0, 2) === '- ') extract[key].push(line.slice(2))
  }

  return extract
}
